import React from "react";
import { Button } from "./common/Button";
import { Container } from "./common/Container";

import DemoImgTwo from "../assets/about/imgTwo.webp";
import DemoImgThree from "../assets/about/imgOne.webp";

import { FaArrowRight, FaCheckCircle, FaCopy } from "react-icons/fa";
import { Link } from "react-router-dom";
import AboutImg from "../assets/about/main.webp";

const AboutSection = () => {
  return (
    <Container>
      <div className="flex flex-col items-center lg:flex-row lg:space-x-10 xl:space-x-16">
        <div className="order-2 flex flex-col justify-center lg:order-1 lg:w-7/12 xl:w-1/2">
          <div className="border-b border-dashed border-[#d4d4d491] pb-4">
            <span className="fontSuse mb-2 flex items-center text-base font-medium text-custom-orange md:mb-3">
              <FaCopy className="mr-2" /> About Our Company
            </span>
            <h2 className="mb-5 text-[24px] font-bold leading-snug text-custom-dark-blue sm:text-[36px] lg:text-[40px] xl:text-[44px] 2xl:text-[48px]">
              We are digital creative agency in Chitral
            </h2>
            <p className="mb-2 text-justify text-xs font-light text-gray-600 sm:text-sm">
              Hub Be-Connect is a dynamic tech start-up based in Chitral,
              dedicated to equipping individuals and businesses with essential
              freelancing skills. We offer short courses and diplomas in areas
              like bookkeeping and graphic design, empowering professionals to
              thrive in the digital economy.
            </p>
            <p className="text-justify text-xs font-light text-gray-600 sm:text-sm">
              Rooted in innovation and community, we foster growth through
              tailored training, collaboration, and knowledge sharing. Our
              expert team is committed to integrity, excellence, and creating
              opportunities that drive success.
            </p>
          </div>

          <div className="mt-4 flex flex-wrap items-center gap-y-2">
            <div className="flex w-1/2 items-center">
              <span>
                <FaCheckCircle className="mr-3 text-custom-orange" />
              </span>
              <p className="m-0 text-xs font-medium text-custom-black xl:text-sm">
                All In One IT Solution Company
              </p>
            </div>
            <div className="flex w-1/2 items-center">
              <span>
                <FaCheckCircle className="mr-3 text-custom-orange" />
              </span>
              <p className="m-0 text-xs font-medium text-custom-black xl:text-sm">
                Amazing Expert Teams
              </p>
            </div>
            <div className="flex w-1/2 items-center">
              <span>
                <FaCheckCircle className="mr-3 text-custom-orange" />
              </span>
              <p className="m-0 text-xs font-medium text-custom-black xl:text-sm">
                Quality Solution For Business
              </p>
            </div>
            <div className="flex w-1/2 items-center">
              <span>
                <FaCheckCircle className="mr-3 text-custom-orange" />
              </span>
              <p className="m-0 text-xs font-medium text-custom-black xl:text-sm">
                24/7 Quick Supports
              </p>
            </div>
          </div>
          <div className="mt-6">
            <Link to="/about">
              <Button
                className={
                  "bg-custom-black text-sm uppercase text-white hover:bg-custom-dark-blue sm:text-[16px]"
                }
              >
                Learn More <FaArrowRight className="ml-3 text-white" />
              </Button>
            </Link>
          </div>
        </div>

        <div className="relative order-1 mb-10 w-[100%] flex-1 sm:w-full lg:order-2 lg:mb-0 lg:w-[unset]">
          <div className="relative mb-3 w-[100%] overflow-hidden">
            <img
              src={AboutImg}
              alt="about img"
              className="h-auto max-h-[260px] w-full rounded-2xl object-cover shadow-lg"
            />
          </div>
          <div className="hidden h-full flex-wrap justify-between sm:flex">
            <div className="mb-6 max-h-[100%] w-full sm:mb-0 sm:w-[67%]">
              <img
                src={DemoImgTwo}
                alt="about img"
                className="h-full max-h-[260px] w-full rounded-2xl object-cover shadow-lg"
              />
            </div>
            <div className="max-h-[100%] w-full sm:w-[30%]">
              <img
                src={DemoImgThree}
                alt="about img"
                className="h-full max-h-[260px] w-full rounded-2xl object-cover shadow-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default AboutSection;
